import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetStore } from 'src/store';

import { AdminGetUserResponse } from '@itm/shared-frontend/lib/components/initial';

type AuthState = {
  identityUser: AdminGetUserResponse | null;
  isLoginJourneyFinished: boolean;
};

const initialState: AuthState = {
  identityUser: null,
  isLoginJourneyFinished: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIdentityUser(state: AuthState, action: PayloadAction<AdminGetUserResponse | null>) {
      state.identityUser = action.payload;
    },
    setIsLoginJourneyFinished(state: AuthState, action: PayloadAction<boolean>) {
      state.isLoginJourneyFinished = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Cleanup
    builder.addCase(resetStore, (state: AuthState) => {
      Object.assign(state, initialState);
    });
  },
});

export const { setIdentityUser, setIsLoginJourneyFinished } = authSlice.actions;

export default authSlice.reducer;
